const getClient = async (clientId: string, isDev: boolean) => {
  try {
    // eslint-disable-next-line no-undef
    const requestHeaders: HeadersInit = new Headers();
    requestHeaders.set('Content-Type', 'application/json');
    requestHeaders.set('clientid', clientId);

    const response = await fetch(
      `https://api-v2${isDev ? '-dev2' : ''}.hereworks.tech/button/client?clientid=${clientId}`,
      {
        method: 'GET',
        headers: requestHeaders,
      },
    );
    const json = await response.json();
    return json;
  } catch (error) {
    // console.error(error);
    return null;
  }
};

export default getClient;
